import React, { useContext, useEffect } from "react";
import ObraForm from "../components/proyectos/ObraForm";
import { MenuContext } from "../context/MenuContext";
import { ProyectosContext } from "../context/ProyectosContext";

// Settings of the obra (name, location, progress options, image) without
// leaving it.
const ConfiguracionObra = ({ idProyecto }) => {
  const { setSelected } = useContext(MenuContext);
  const { getSingleProyecto } = useContext(ProyectosContext);

  useEffect(() => {
    setSelected({ title: "Configuración" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const recargar = () => getSingleProyecto(idProyecto);

  return (
    <div className="container-fluid h-100" style={{ overflowY: "auto" }}>
      <div
        className="card border shadow-sm my-3 p-4"
        style={{ borderRadius: 10, maxWidth: 760 }}
      >
        <ObraForm configuracion handleCancel={recargar} handleCallback={recargar} />
      </div>
    </div>
  );
};

export default ConfiguracionObra;
